import { IconTypes } from '../../components/common';

export const getPromoIconType = (isAvailable: boolean): IconTypes => isAvailable
  ? IconTypes.percentRoundedBlue
  : IconTypes.percentRoundedDotted;
